"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Root = void 0;
var tslib_1 = require("tslib");
var ui_text_1 = require("@hopin-team/ui-text");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
exports.Root = (0, styled_components_1.default)(ui_text_1.Text)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n"], ["\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n"])));
var templateObject_1;
//# sourceMappingURL=root.js.map